var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showCmpt && _vm.mergeFlag,
          expression: "showCmpt && mergeFlag",
        },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "yxtbiz-merge-evaluation",
    },
    [
      _c(
        "div",
        { staticClass: "yxtbiz-merge-evaluation__title" },
        [
          _c(
            "yxtf-checkbox",
            {
              on: { change: _vm.handleOnlyStartedChange },
              model: {
                value: _vm.onlyStarted,
                callback: function ($$v) {
                  _vm.onlyStarted = $$v
                },
                expression: "onlyStarted",
              },
            },
            [
              _c(
                "yxtf-tooltip",
                {
                  attrs: {
                    placement: "bottom",
                    "open-filter": true,
                    content: _vm.$t("pc_biz_o2o_lbl_onlyviewstartedtask"),
                  },
                },
                [
                  _c("span", { staticClass: "color-59" }, [
                    _vm._v(
                      _vm._s(_vm.$t("pc_biz_o2o_lbl_onlyviewstartedtask"))
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("yxtf-divider"),
      _c(
        "div",
        { staticClass: "over-hidden" },
        [
          _c("yxtf-scrollbar", { attrs: { "fit-height": true } }, [
            _c(
              "div",
              { staticClass: "yxtbiz-merge-evaluation__body" },
              [
                _vm.taskList.length > 0
                  ? _vm._l(_vm.taskList, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.taskId,
                          staticClass: "yxtbiz-merge-evaluation__task hand",
                          class: { "eval-item-selected": item.selected },
                          on: {
                            click: function ($event) {
                              return _vm.showDetail(item)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "font-size-16 lh24",
                              class: { "font-bold": item.selected },
                            },
                            [
                              _c(
                                "yxtf-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    "open-filter": true,
                                    content: item.taskName,
                                    placement: "top",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "task-title hand ellipsis d-in-block color-59",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.taskName) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "mt4 font-size-12 lh20 merge-evaluation-task-status",
                            },
                            [
                              _c("yxt-svg", {
                                attrs: {
                                  "icon-class": _vm.svgClass(item),
                                  width: "18px",
                                  height: "18px",
                                  "remote-url":
                                    _vm.$staticBaseUrl +
                                    "ufd/d8a55a/o2o/pc/svg",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "inlineBlock ml4 font-size-12 lh20 color-bf",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.taskStatus(item)) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    })
                  : _vm.loadEnd && _vm.taskList.length === 0
                  ? _c("yxtf-empty", {
                      staticClass: "pv24",
                      attrs: { size: "small" },
                    })
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }